import { ReactNode } from 'react';
import CustomTooltip from '../Tooltip/Tooltip';

interface ListShortenedByCountProps {
  value: string | ReactNode;
  count?: number;
  tooltipId?: string;
  tooltipContent?: ReactNode;
  tooltipPlacement?: 'top' | 'bottom';
}

const ListShortenedByCount = ({ 
  value, 
  count = 0, 
  tooltipId, 
  tooltipContent, 
  tooltipPlacement = 'top' 
}: ListShortenedByCountProps) => {
  const uniqueId = tooltipId || `value-with-count-${Math.random().toString(36).substring(2, 9)}`;
  
  return (
    <div id={tooltipContent ? uniqueId : undefined}>
      <span>{value}</span>
      {count > 0 && <span> +{count}</span>}
      
      {tooltipContent && tooltipId && (
        <CustomTooltip targetId={uniqueId} placement={tooltipPlacement}>
          {tooltipContent}
        </CustomTooltip>
      )}
    </div>
  );
};

export default ListShortenedByCount;
